
<template>
	<article class="form-section-print-view">
		<div v-if="project" class="letterhead d-flex flex-row justify-content-between align-items-center">
			<img v-if="companyLogoSrc" :src="companyLogoSrc" class="logo mr-3">
			<div>
				<h3 class="text-right">
					<span class="ml-2">#{{ project.job_num }}: {{ project.job_name }}</span>
					<div><small class="text-muted">Project Note</small></div>
				</h3>

				<button class="btn btn-light form-button mr-4 float-right" v-on:click="printPage">
					<i class="fa fa-print"></i>
					Print
				</button>

				<button v-if="userIsVerified" class="btn btn-light form-button mr-2 float-right" v-on:click="sendModalVisible = true">
					<i class="fa fa-envelope"></i>
					Send
				</button>
			</div>
		</div>


		<div class="form-details" v-if="'job_num' in project && 'job_name' in project">
			<h4 class="title">
				Note for Project  #{{ project.job_num }}, {{ project.job_name }}
			</h4>
		</div>


		<div v-if="noteIsFetched">
			<job-note :note="note"></job-note>
		</div>

		<send-document-modal
			document-type="Note"
			:visible="sendModalVisible"
			:customer="project.Customer"
			:employees="project.User"
			v-on:closeModal="sendModalVisible = false"
			v-on:send="sendNote">		
		</send-document-modal>

	</article>
</template>


<script type="text/javascript">

import TableList from "@/components/TableList"
import Field from "@/components/Field"
import SendDocumentModal from "@/components/SendDocumentModal"
import JobNote from "@/components/JobNote"

export default {
	name: "NotePrintView",
	components: {
		TableList,
		Field,
		SendDocumentModal,
		JobNote
	},
	mixins: [],
	data() {
		return {
			note: {},
			noteIsFetched: false,
			project: {},
			sendModalVisible: false,

			userIsVerified: false,

			guestPayload: {
				// userIsVerified = false
				// Only need Company info, notes info
				include: [
					{
						model: "User",
						fields: ["first_name", "last_name"]
					},
					{
						// Attachments
						model: "UploadFile",
						fields: ["thumb_filename", "filename"]
					}
				]
			},

			verifiedPayload: {
				// userIsVerified = true
				// Need Company info, notes info, AND info on employee/
				// subcontacts for Send Modal Dropdowns
				is_shared: true,
				include : [
					{
						model: "User",
						fields: ["first_name", "last_name"]
					},
					{
						// Attachments
						model: "UploadFile",
						fields: ["thumb_filename", "filename", "id", "slug"]
					},
					{
						// Project Info
						model: "Job",
						fields: ["job_num", "job_name", "job_id", "User", "Customer", "Company"],
						include: [
							{
								// Job Employees (email modal)
								model: "User",
								fields: ["first_name", "last_name", "email", "id"]
							},
							{
								// Customer (bridge to SubContacts)
								model: "Contact",
								fields: ["SubContacts"],
								include: [
									{
										// SubContacts (email modal)
										model: "Contact",
										fields: ["name", "email"]
									}
								]
							},
							{
								model: "Company",
								fields: ["ProfileImage"],
								include: [
									{
										model: "ProfileImage",
										fields: ["slug", "filename"]
									}
								]
							}
						]
					}
				]
			}
		}
	},
	computed: {
		companyLogoSrc() {
			let fileImage = {}

			if ('Company' in this.project && 'ProfileImage' in this.project.Company && this.project.Company.ProfileImage)
				fileImage = this.project.Company.ProfileImage

			if (fileImage)
				return window.apiRoot+"resources/profile-images/"+fileImage.slug+"/"+fileImage.filename
			else
				return false
		}
	},
	methods: {
		printPage() {
			window.print()
		},
		sendNote(payload) {
			// Payload includes:
			//    additional - emails typed into modal
			//    employeeRecipients - user ids of employees
			//    recipients - user ids of subcontacts of customer

			let vm = this
			this.spinner(true)

			payload.note_id = this.note.id                   // Used to build URL
			payload.userIdList = payload.employeeRecipients  // List of internal employee ids to email
			payload.contactIdList = payload.recipients       // List of customer subcontact ids to email

			// No longer needed
			delete payload.employeeRecipients
			delete payload.recipients

			this.postData("JobNote/send", payload).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.sendModalVisible = false
					//vm.alertSuccess("Note #"+vm.note.note_id+" was sent successfully.")

					// Successful? Update file to be visible
					vm.note.UploadFile.forEach(file => {

						file.sharing_on = 1
						vm.postData("UploadFile/update", file).then(fileResponse => {
							if (!fileResponse.success) {
								//vm.alertErrors("Note #"+vm.note.note_id+" attachment could not be posted.")
							}
						})
					})

				} else {
					//vm.alertErrors("Note #"+vm.note.note_id+" could not be sent.")
				}
			})
		},

		fetchCompany() {
			let vm = this

			let payload = {
				fields: ["ProfileImage"],
				include: [
					{
						model: "ProfileImage",
						fields: ["slug", "filename"]
					}
				]
			}

			this.getJSON("Company/find/"+vm.project.tenant_id, payload).then(response => {
				if (response.success) {
					vm.project.Company = response.data
				}
			})
		},

		fetchProject() {

			let params = {
				is_shared: true
			}

			let vm = this

			this.getJSON("Job/find/"+this.$route.params.slug, params).then(response => {
				if (response.success) {
					vm.project = response.data
					vm.fetchCompany()
				}
			})
		},

		fetchNote(payload) {
			let vm = this

			vm.spinner(true)

			// BY DEFAULT:
			//   Fetch info of user who last updated note
			//   Fetch info on project (name, number)
			// IF VERIFIED:
			//   Fetch project employees for send modal
			//   Fetch customer subcontacts for send modal
			this.getJSON("JobNote/find/"+vm.$route.params.note_slug, payload).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.note = response.data
					vm.noteIsFetched = true

					if (vm.userIsVerified) {
						vm.project = response.data.Job
					}
					else
						vm.fetchProject()
				}
			})
		}
	},
	created() {

		// Check if page user is logged in
		// Not logged in? Do not allow sending to others
		if ('id' in this.$store.userDetails) {
			this.userIsVerified = true
			this.fetchNote(this.verifiedPayload)
		} else {
			this.userIsVerified = false
			this.fetchNote(this.guestPayload)
		}

		this.$store.printMode = true
	}
}
</script>



<style type="text/css" scoped>
article {
	max-width: 1000px;
	margin: auto;
}

.form-details {
	margin-top: 30px;
	padding: 15px;
	background-color: #6c757d;
	color: white;
}

@media print {
	.form-button {
		display: none;
	}
}

.title {
	margin: 0px;
	padding: 0px;
}


.form-section pre {
	margin-bottom: 0;
}

.form-section-print-view {
	border: 1px solid #e0e0e0;
	padding: 15px;
	padding-top: 0;
	background-color: white;
}

.form-section-print-view h4 {
	padding: 15px;
	background: #6c757d;
	color: white;
	margin-left: -15px;
	margin-right: -15px;
	text-decoration: none;
}

.form-section-print-view.highlighted-section h4 {
	background: #b1690c;
}

.form-section-print-view .field-container {
	border-bottom: 1px solid #e0e0e07a;
}

.form-section-print-view .field {
	padding-top: 10px;
	padding-bottom: 10px;
}

.form-section-print-view .field:last-child {
	border-bottom: none;
}

.form-section-print-view .field h5 {
	margin-bottom: 0;
}

.form-section-print-view .field.field-type-boolean h5,
.form-section-print-view .field.field-type-text h5 {
	width: 80%;
}


@media print {
	pre {
		border: none!important;
	}

	article {
		background-color: white!important;
	}
}
</style>

